import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CabService } from 'src/app/_service/cab.service';
import { SharedService } from 'src/app/_service/shared.service';

@Component({
  selector: 'app-cab-details-modal',
  templateUrl: './cab-details-modal.component.html',
  styleUrls: ['./cab-details-modal.component.css']
})
export class CabDetailsModalComponent implements OnInit {

  dataLoaded:boolean=false;CabForm: FormGroup;loading:boolean=false;submitted:boolean=false;modalData:any;

  constructor(public dialogRef: MatDialogRef<CabDetailsModalComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog,private dialog:MatDialog,
  private router:Router,private sharedService:SharedService,private formBuilder: FormBuilder,private cabService: CabService) {
    this.modalData = this.data;
    this.CabForm = this.formBuilder.group({
      'price' : [null, Validators.required],
      'pickup_point': [null, Validators.required],
      'comments' : [''],
      'pickup_date': [null, Validators.required],
      'pickup_time': [null, Validators.required]
    });
    if(this.modalData.status == 2 || this.modalData.status == 4) {
      this.CabForm.controls['price'].setValidators(null);
      this.CabForm.controls['price'].updateValueAndValidity();
    }
  }

  ngOnInit(): void {
    this.getCabDetail();
  }

  async updateCabDetails(){
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.CabForm.invalid) {
        this.loading = false;
        return;
    }
    await this.cabService.changeCabStatus(this.modalData, this.CabForm.value).subscribe((data:any) => {
          this.sharedService.presentToast(data.msg);
          this.loading = false;
    }, error => {
          this.sharedService.checkError(error);
          this.loading = false;
    });
  }

  CloseModal(): void {
    this.dialogRef.close();
  }

  getCabDetail(){
    this.dataLoaded = false;
    this.cabService.getCabDetail(this.modalData.ipd_id).subscribe((data:any) => {
      if(data.status) {
        this.dataLoaded = true;
        this.CabForm.controls['pickup_point'].setValue(data.data.pickup_point);
        this.CabForm.controls['comments'].setValue(data.data.cab_comment);
        this.CabForm.controls['pickup_time'].setValue(data.data.pickup_time);
        let pickupDate = (data.data.pickup_date!=null)?new Date(data.data.pickup_date*1000):null;
        this.CabForm.controls['pickup_date'].setValue(pickupDate);
      }
    }, error => {
      this.sharedService.checkError(error);
      this.dataLoaded = true;
    });
  }

  get f() { return this.CabForm.controls; }

}
